import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dynamic-indicator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowDynamic = _resolveComponent("ArrowDynamic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass([_ctx.getTextColor, 'dynamic-indicator__amount-difference'])
    }, [
      _createVNode(_component_ArrowDynamic, { value: _ctx.getAmountDifference }, null, 8, ["value"]),
      _createElementVNode("span", null, _toDisplayString(_ctx.getAmountDifferenceValue) + _toDisplayString(_ctx.postfix), 1)
    ], 2)
  ]))
}